import { useTranslations } from 'next-intl'
import { MouseEvent } from 'react'
import {
  Slide as SlideType,
  useLightboxState,
} from 'yet-another-react-lightbox'

import { cn } from '@/shared/lib'
import { getExternalImageURL } from '@/shared/ui'

type LightboxImageProps = {
  slide: SlideType
  roomName: string
  className?: string
}

export const Slide = ({ slide, roomName, className }: LightboxImageProps) => {
  const t = useTranslations('room_detail')

  const { currentIndex } = useLightboxState()

  const handleContextMenu = (event: MouseEvent<HTMLImageElement>) => {
    event.preventDefault()
  }

  return (
    <div
      className={cn(
        'relative flex h-full max-h-[80vh] w-full max-w-[80vw] items-center justify-center',
        className,
      )}
    >
      {/* eslint-disable-next-line @next/next/no-img-element */}
      <img
        src={getExternalImageURL({ src: slide.src })}
        alt={t('thumbnail', { roomName, index: currentIndex + 1 })}
        className="max-h-full min-h-3/4 object-contain select-none"
        onContextMenu={handleContextMenu}
      />
    </div>
  )
}
